import { MuiCardMedia } from '@/components/blocks/MuiCardMedia';
import { PROMOTION_TYPES } from '@/data/constants/promoIconConstants';
import { ProductType } from '@/data/types/Product';
import { usePromoIconsWithStyleAndUrls } from '@/data/utils/usePromoIcons';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, SxProps, Theme } from '@mui/material';

const showBeforePriceList = [PROMOTION_TYPES.PROMOICON_NLP] as string[];

export const PromoIcons = ({ product, imageSx }: { product: ProductType; imageSx?: SxProps<Theme> }) => {
	const { promotion, promotions } = usePromoIconsWithStyleAndUrls({ product });
	const showPromo = promotion?.identifier && showBeforePriceList.includes(promotion.identifier);
	if (!showPromo) return null;
	const rulePromoIcon_CE_and_NLP = [
		PROMOTION_TYPES.PROMOICON_NLP,
		PROMOTION_TYPES.PROMOICON_CE,
	].every((identifier) => promotions.some((promotion) => promotion?.identifier === identifier));
	if (rulePromoIcon_CE_and_NLP) return null;
	return (
		<Box mr={'5px'}>
			<MuiCardMedia
				component="img"
				image={promotion?.icon}
				sx={imageSx ?? promotion?.styles}
				title={promotion.identifier}
				className={setClassName(promotion.identifier)}
			></MuiCardMedia>
		</Box>
	);
};
